import * as React from "react";
import {JobInvoicePath, JobInvoicePathLabelEnum} from "../../../../model/job/JobInvoicePath";

interface IProps {
	value: JobInvoicePath;
}

export const JobInvoicePathPresenter: React.SFC<IProps> = (props) => {
	return (
		<span>{JobInvoicePathLabelEnum[props.value]}</span>
	);
};